var _style, _polyline, _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighLowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "high-tide-2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 266.7 363.7",
    style: {
      enableBackground: "new 0 0 266.7 363.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:66.6667;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:133.3333;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "secondary",
    className: "st0",
    points: "66.6,166.6 133.3,233.3 200,166.6 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "secondary-2",
    className: "st0",
    x1: 133.3,
    y1: 33.3,
    x2: 133.3,
    y2: 228.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "primary",
    className: "st0",
    d: "M33.3,330.4h200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighLowIcon);
export default __webpack_public_path__ + "static/media/high_low_icon.f415b198170d03b8cd9594c4b1e478d0.svg";
export { ForwardRef as ReactComponent };